import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Rocket, Check, TrendingUp } from "lucide-react";

const VOTED_MOTION = { initial: { scale: 0.6, opacity: 0 }, animate: { scale: 1, opacity: 1 } };

export const VoteBanner = () => {
  const [voted, setVoted] = useState(false);
  const [count, setCount] = useState(1287);

  const handleVote = () => {
    if (voted) return;
    setVoted(true);
    setCount((c) => c + 1);
  };

  return (
    <div
      data-testid="vote-banner"
      className="sticky top-0 z-50 w-full border-b border-white/10 backdrop-blur-xl bg-[#0a0a0a]/70"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3 text-center sm:text-left">
          <span className="hidden sm:flex h-9 w-9 items-center justify-center rounded-lg bg-[#FFCC00] text-[#0a0a0a]">
            <Rocket size={18} strokeWidth={2.5} />
          </span>
          <p className="font-body text-sm sm:text-base font-semibold text-white">
            Like <span className="text-[#FF3B30] font-bold">SlotSaver</span>? Support us with an
            Upvote in <span className="text-[#FFCC00]">Fabrizio Romano</span>'s contest! 🚀
          </p>
        </div>

        <button
          data-testid="upvote-button"
          onClick={handleVote}
          className={`group relative flex items-center gap-2 rounded-full px-5 py-2 font-head text-lg font-bold uppercase tracking-wide transition-all duration-300 ${
            voted
              ? "bg-[#25D366] text-[#0a0a0a]"
              : "bg-[#FF3B30] text-white hover:scale-105 hover:shadow-[0_0_24px_rgba(255,59,48,0.6)]"
          }`}
        >
          <AnimatePresence mode="wait">
            {voted ? (
              <motion.span
                key="voted"
                {...VOTED_MOTION}
                className="flex items-center gap-2"
              >
                <Check size={18} strokeWidth={3} /> Voted!
              </motion.span>
            ) : (
              <motion.span key="vote" className="flex items-center gap-2">
                <TrendingUp size={18} strokeWidth={2.5} /> Upvote
              </motion.span>
            )}
          </AnimatePresence>
          <span className="font-mono text-sm tabular-nums opacity-90" data-testid="upvote-count">
            {count.toLocaleString("it-IT")}
          </span>
        </button>
      </div>
    </div>
  );
};

export default VoteBanner;
